import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import type { TGetGrowthToolsQueryParams } from '../api/types/growthTools'

export function useGrowthToolsQueryArgs() {
  const [searchParams] = useSearchParams()

  const queryArgs = useMemo<TGetGrowthToolsQueryParams>(() => {
    const query = searchParams.get('query')?.trim() ?? ''
    const sourceType = searchParams.get('source_type')?.trim() ?? ''
    const contentType = searchParams.get('content_type')?.trim() ?? ''
    const args: TGetGrowthToolsQueryParams = {}
    if (query) args.query = query
    if (sourceType && sourceType !== 'all') args.source_type = sourceType
    if (contentType && contentType !== 'all') args.content_type = contentType
    return args
  }, [searchParams])

  const resetKey = useMemo(() => JSON.stringify(queryArgs), [queryArgs])

  return { queryArgs, resetKey }
}
